import React from 'react';
import { Tabs } from 'antd';
import { BasicTable } from './BasicTable/BasicTable';
import { GenericCoupons } from './GenericCoupons/GenericCoupons';

const { TabPane } = Tabs;

const ManageCouponsComponent: React.FC = () => {
  return (
    <>
      <div style={{ marginBottom: '20px', flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
        <h4 style={{ fontWeight: 'bold' }}>First Recharge Coupons & Offers</h4>
      </div>
      <Tabs defaultActiveKey="single" destroyInactiveTabPane={false}>
        <TabPane tab="Single-Use Coupons" key="single">
          <BasicTable />
        </TabPane>
        <TabPane tab="Generic Coupons (all users)" key="generic">
          <GenericCoupons />
        </TabPane>
      </Tabs>
    </>
  );
};

export default ManageCouponsComponent;
